export default __webpack_public_path__ + "resources/driving_school_1024x512_f7041de6f34789e69063d1820edfe490.hdr";